$(function($) {

    $('[goto-link]').each(function() {
        var $element = $(this);

        var links = $element.find('a[href]:not([href=""])');
        links.bind('click', function(e) { e.stopPropagation(); });

        var a = links[0];
        if (!a) {
            $element.css('cursor', 'auto');
            return;
        }

        $element.css('cursor', 'pointer');

        $element.one("click",
            function() {

                var href = a.href;
                var target = a.getAttribute("target");

                if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                    var referLink = document.createElement('a');
                    referLink.href = href;
                    referLink.target = target;
                    document.body.appendChild(referLink);
                    referLink.click();
                } else if (target === "_blank") {
                    window.open(href);
                } else {
                    location.href = href;
                }

            });
    });

});